export const NHOV_EFFECT_LEVEL_SOFTCAP_KNEE = 308;
// Compression applied to branch-level input past the knee. At the current 0.5 the
// post-knee curve is square-root equivalent: knee * (raw/knee) ** 0.5 === sqrt(knee * raw).
export const NHOV_EFFECT_LEVEL_POST_KNEE_SLOPE = 0.5;

export function resolveEffectiveNHovEffectLevel(rawLevel: number): number {
  const knee = NHOV_EFFECT_LEVEL_SOFTCAP_KNEE;
  const slope = NHOV_EFFECT_LEVEL_POST_KNEE_SLOPE;

  if (!Number.isFinite(rawLevel) || rawLevel <= 0) return 0;
  if (rawLevel <= knee) return rawLevel;
  if (!Number.isFinite(slope) || slope <= 0) return knee;

  return knee * Math.pow(rawLevel / knee, slope);
}

export interface ResolveNHovBranchEffectiveLevelOptions {
  readonly level: number;
  readonly exponent: number;
}

export function resolveNHovBranchEffectiveLevel(
  options: ResolveNHovBranchEffectiveLevelOptions,
): number {
  const { level, exponent } = options;
  if (!Number.isFinite(level) || level <= 0) return 0;
  if (!Number.isFinite(exponent)) return 0;
  const effectLevel = resolveEffectiveNHovEffectLevel(level);
  const result = Math.pow(effectLevel, exponent);
  if (!Number.isFinite(result) || result <= 0) return 0;
  return result;
}

// Additive bonus applied to a branch's base growth exponent. Resolved from
// acquired Hov skills upstream; clamped to a finite non-negative value so a
// missing or malformed bonus stays neutral.
export function normalizeNHovGrowthExponentBonus(
  value: number | undefined,
): number {
  if (value === undefined) return 0;
  if (!Number.isFinite(value) || value <= 0) return 0;
  return value;
}
